/* NordSock theme JS */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (t) {
      var m = document.querySelector('[data-menu]');
      if (m) m.classList.toggle('is-open');
    }
  });

  /* ---------- Cart helpers ---------- */
  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function clearCart() {
    return fetch(rootUrl() + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '0'; el.hidden = true; });
      })
      .catch(function () {});
  }
  /* Customer went to checkout and came back without buying: empty the cart */
  function emptyIfReturnedFromCheckout() {
    var flag = null;
    try { flag = sessionStorage.getItem('ns_to_checkout'); } catch (e) {}
    if (!flag) return;
    try { sessionStorage.removeItem('ns_to_checkout'); } catch (e) {}
    clearCart().then(function () {
      if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
    });
  }
  emptyIfReturnedFromCheckout();
  window.addEventListener('pageshow', function (e) { if (e.persisted) emptyIfReturnedFromCheckout(); });

  /* ---------- Helpers ---------- */
  var I18N = window.NordSockI18n || {};
  function fmtKr(cents) {
    var k = Math.round(cents / 100);
    return String(k).replace(/\B(?=(\d{3})+(?!\d))/g, I18N.sep || ' ') + ' kr';
  }

  function parseColorMap(txt) {
    var map = {};
    String(txt || '').split(/\r?\n/).forEach(function (line) {
      var p = line.split('|').map(function (s) { return s.trim(); });
      if (p.length < 2 || !p[0]) return;
      var type = 'solid', cols;
      if (p.length >= 3) { type = (p[1] || 'solid').toLowerCase(); cols = p[2]; } else { cols = p[1]; }
      map[p[0].toLowerCase()] = { type: type, cols: cols.split(',').map(function (s) { return s.trim(); }).filter(Boolean) };
    });
    return map;
  }

  function bgFromEntry(e) {
    var a = e.cols[0] || '#ccc', b = e.cols[1] || '#ffffff';
    switch (e.type) {
      case 'stripes': return 'linear-gradient(to bottom,' + a + ' 0 20%,' + b + ' 20% 40%,' + a + ' 40% 60%,' + b + ' 60% 80%,' + a + ' 80%)';
      case 'pinstripe': return 'linear-gradient(to bottom,' + a + ' 0 27%,' + b + ' 27% 33%,' + a + ' 33% 47%,' + b + ' 47% 53%,' + a + ' 53% 67%,' + b + ' 67% 73%,' + a + ' 73%)';
      case 'dots': return 'radial-gradient(circle,' + b + ' 0 33%, transparent 37%) 50% 50%/33.4% 33.4%,' + a;
      case 'half': return 'linear-gradient(90deg,' + a + ' 50%,' + b + ' 50%)';
      default: return a;
    }
  }

  /* ---------- Product ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { console.error('NordSock: product JSON', err); return; }

    var ci = data.colorIndex, si = data.sizeIndex;
    var map = parseColorMap(data.colorMap);
    var colors = ci > -1 && data.options[ci] ? data.options[ci].values : [null];
    var sizes = si > -1 && data.options[si] ? data.options[si].values : [null];
    var colorName = ci > -1 && data.options[ci] ? data.options[ci].name : '';
    var sizeName = si > -1 && data.options[si] ? data.options[si].name : '';

    function matches(v, color, size) {
      return (ci < 0 || v.options[ci] === color) && (si < 0 || v.options[si] === size);
    }
    function findVariant(color, size) {
      var list = data.variants.filter(function (v) { return matches(v, color, size); });
      return list.find(function (v) { return v.available; }) || list[0] || null;
    }
    function isAvail(color, size) {
      return data.variants.some(function (v) { return matches(v, color, size) && v.available; });
    }
    function colorHasStock(color) {
      return data.variants.some(function (v) { return (ci < 0 || v.options[ci] === color) && v.available; });
    }
    function firstAvailSize(color) {
      for (var i = 0; i < sizes.length; i++) if (isAvail(color, sizes[i])) return sizes[i];
      return sizes[0];
    }
    function colorBg(name) {
      if (!name) return '#ccc';
      var v = data.variants.find(function (x) { return x.options[ci] === name && x.image; });
      var imgBg = v ? 'url("' + v.image + '") center/cover no-repeat #fff' : null;
      if (data.swatchStyle !== 'color' && imgBg) return imgBg;
      var e = map[String(name).toLowerCase()];
      if (e) return bgFromEntry(e);
      return imgBg || '#cfd5dd';
    }

    /* initial state */
    var activeSwatch = root.querySelector('.swatch.is-active');
    var activeSize = root.querySelector('.size-btn.is-active');
    var firstAvail = data.variants.find(function (v) { return v.available; }) || data.variants[0];
    var state = {
      color: activeSwatch ? activeSwatch.dataset.swatch : (ci > -1 && firstAvail ? firstAvail.options[ci] : null),
      size: activeSize ? activeSize.dataset.size : (si > -1 && firstAvail ? firstAvail.options[si] : null),
      tier: 0,
      rows: []
    };

    /* ---------- Gallery ---------- */
    var slides = Array.prototype.slice.call(root.querySelectorAll('.gallery-slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var cur = 0;
    function show(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === cur;
        s.classList.toggle('is-active', on);
        var vid = s.querySelector('video');
        if (vid) { if (on) { vid.play && vid.play().catch(function () {}); } else { vid.pause && vid.pause(); } }
      });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
      var tc = thumbs[cur];
      if (tc && tc.parentElement) tc.parentElement.scrollTo({ left: tc.offsetLeft - 20, behavior: 'smooth' });
    }
    function showColor(color) {
      if (ci < 0) return;
      var v = data.variants.find(function (x) { return x.options[ci] === color && x.media && (si < 0 || x.options[si] === state.size); }) ||
              data.variants.find(function (x) { return x.options[ci] === color && x.media; });
      if (!v) return;
      var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(v.media); });
      if (idx > -1) show(idx);
    }
    var prev = root.querySelector('[data-gallery-prev]'), next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.thumb); }); });
    var gm = root.querySelector('.gallery-main'), sx = null;
    if (gm) {
      gm.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      gm.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
        sx = null;
      });
    }

    /* ---------- Swatches ---------- */
    root.querySelectorAll('[data-swatch-fill]').forEach(function (el) {
      el.style.background = colorBg(el.dataset.swatchFill);
    });
    var colorLabel = root.querySelector('[data-color-label]');
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-swatch]'));
    var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-size]'));

    swatches.forEach(function (b) {
      b.classList.toggle('is-soldout', !colorHasStock(b.dataset.swatch));
      b.addEventListener('click', function () {
        state.color = b.dataset.swatch;
        if (si > -1 && !isAvail(state.color, state.size)) state.size = firstAvailSize(state.color);
        state.rows.forEach(function (r) { r.color = state.color; r.size = state.size; });
        syncMain();
        renderRows();
        showColor(state.color);
      });
    });
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        state.size = b.dataset.size;
        state.rows.forEach(function (r) { r.size = state.size; if (!isAvail(r.color, r.size)) r.color = state.color; });
        syncMain();
        renderRows();
      });
    });
    function syncMain() {
      swatches.forEach(function (b) { b.classList.toggle('is-active', b.dataset.swatch === state.color); });
      if (colorLabel) colorLabel.textContent = state.color || '';
      sizeBtns.forEach(function (b) {
        var ok = isAvail(state.color, b.dataset.size);
        b.disabled = !ok;
        b.classList.toggle('is-soldout', !ok);
        b.classList.toggle('is-active', b.dataset.size === state.size);
      });
    }

    /* ---------- Bundles ---------- */
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    var activeTierEl = tiers.find(function (t) { return t.classList.contains('is-active'); });
    state.tier = activeTierEl ? tiers.indexOf(activeTierEl) : 0;
    /* Preselect a bundle from the link, e.g. /products/...?pakke=5 */
    try {
      var want = parseInt(new URLSearchParams(window.location.search).get('pakke'), 10);
      if (want) {
        var hit = tiers.findIndex(function (t) { return parseInt(t.dataset.qty, 10) === want; });
        if (hit > -1) state.tier = hit;
      }
    } catch (err) {}

    function tierQty() {
      var t = tiers[state.tier];
      return t ? parseInt(t.dataset.qty, 10) || 1 : 1;
    }
    function ensureRows(n) {
      while (state.rows.length < n) state.rows.push({ color: state.color, size: state.size });
    }

    function makeSelect(values, selected, labelFor, disabledFor) {
      var s = document.createElement('select');
      values.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v;
        o.textContent = labelFor ? labelFor(v) : v;
        if (disabledFor && disabledFor(v)) o.disabled = true;
        if (v === selected) o.selected = true;
        s.appendChild(o);
      });
      return s;
    }

    function renderRows() {
      tiers.forEach(function (t, k) {
        t.classList.toggle('is-active', k === state.tier);
        var inp = t.querySelector('input[type=radio]');
        if (inp) inp.checked = k === state.tier;
        var box = t.querySelector('[data-tier-rows]');
        if (box && k !== state.tier) box.innerHTML = '';
      });
      var tEl = tiers[state.tier];
      if (!tEl) return;
      var box = tEl.querySelector('[data-tier-rows]');
      if (!box) return;
      box.innerHTML = '';
      if (ci < 0 && si < 0) return;
      var n = tierQty();
      ensureRows(n);

      var lbl = document.createElement('p');
      lbl.className = 'tier-rows-label';
      lbl.textContent = [colorName, sizeName].filter(Boolean).join(', ');
      box.appendChild(lbl);

      for (var i = 0; i < n; i++) {
        (function (i) {
          var r = state.rows[i];
          var row = document.createElement('div');
          row.className = 'tier-row';
          var num = document.createElement('span');
          num.className = 'tier-row-num';
          num.textContent = '#' + (i + 1);
          row.appendChild(num);

          var sizeSel;
          if (ci > -1) {
            var wrap = document.createElement('div');
            wrap.className = 'sel sel-color';
            var dot = document.createElement('span');
            dot.className = 'dot';
            dot.style.background = colorBg(r.color);
            var cs = makeSelect(colors, r.color, null, function (c) { return !colorHasStock(c); });
            cs.setAttribute('aria-label', colorName + ' ' + (I18N.pair || 'par') + ' ' + (i + 1));
            cs.addEventListener('change', function () {
              r.color = cs.value;
              dot.style.background = colorBg(r.color);
              if (si > -1 && !isAvail(r.color, r.size)) r.size = firstAvailSize(r.color);
              if (sizeSel) refreshSizeSel(sizeSel, r);
              showColor(r.color);
            });
            wrap.appendChild(dot);
            wrap.appendChild(cs);
            row.appendChild(wrap);
          }
          if (si > -1) {
            var sw = document.createElement('div');
            sw.className = 'sel sel-size';
            sizeSel = document.createElement('select');
            sizeSel.setAttribute('aria-label', sizeName + ' ' + (I18N.pair || 'par') + ' ' + (i + 1));
            refreshSizeSel(sizeSel, r);
            sizeSel.addEventListener('change', function () { r.size = sizeSel.value; });
            sw.appendChild(sizeSel);
            row.appendChild(sw);
          }
          box.appendChild(row);
        })(i);
      }
    }
    function refreshSizeSel(sel, r) {
      sel.innerHTML = '';
      sizes.forEach(function (s) {
        var o = document.createElement('option');
        var ok = isAvail(r.color, s);
        o.value = s;
        o.textContent = ok ? s : s + (I18N.sizeSoldOut || ' – slutsåld');
        o.disabled = !ok;
        if (s === r.size) o.selected = true;
        sel.appendChild(o);
      });
    }

    tiers.forEach(function (t, k) {
      var inp = t.querySelector('input[type=radio]');
      if (inp) inp.addEventListener('change', function () { state.tier = k; renderRows(); });
      t.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        if (state.tier !== k) { state.tier = k; renderRows(); }
      });
    });

    /* ---------- Add to cart ---------- */
    var atc = root.querySelector('[data-atc]');
    var atcText = root.querySelector('[data-atc-text]');
    var errEl = root.querySelector('[data-atc-error]');
    function showErr(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = !msg;
    }
    if (atc) {
      atc.addEventListener('click', function () {
        showErr('');
        var n = tiers.length ? tierQty() : 1;
        ensureRows(n);
        var qty = {};
        var bad = false;
        for (var i = 0; i < n; i++) {
          var r = state.rows[i];
          var v = (ci < 0 && si < 0) ? (data.variants.find(function (x) { return x.available; }) || data.variants[0]) : findVariant(r.color, r.size);
          if (!v || !v.available) { bad = true; break; }
          qty[v.id] = (qty[v.id] || 0) + 1;
        }
        if (bad) { showErr(I18N.unavailable || 'Ett eller flera av valen är slutsålda. Välj en annan färg eller storlek.'); return; }
        var items = Object.keys(qty).map(function (id) { return { id: Number(id), quantity: qty[id] }; });
        atc.disabled = true;
        atc.classList.add('is-loading');
        if (atcText) atcText.textContent = I18N.adding || 'Lägger till…';
        var cartUrl = data.cartUrl || '/cart';
        var toCheckout = data.afterAdd === 'checkout';
        /* Start from an empty cart so only this selection is bought */
        var start = toCheckout ? clearCart() : Promise.resolve();
        start.then(function () {
          return fetch(data.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        }).then(function (res) {
          return res.json().then(function (j) { if (!res.ok) throw j; return j; });
        }).then(function () {
          if (toCheckout) {
            try { sessionStorage.setItem('ns_to_checkout', '1'); } catch (e) {}
            window.location.href = cartUrl.replace(/cart\/?$/, 'checkout');
          } else {
            window.location.href = cartUrl;
          }
        }).catch(function (err) {
          resetAtc();
          showErr((err && (err.description || err.message)) || I18N.error || 'Något gick fel. Försök igen.');
        });
      });
    }
    /* Original button text, saved once so it can always be restored */
    var atcOriginal = atcText ? atcText.textContent : '';
    function resetAtc() {
      if (!atc) return;
      atc.disabled = false;
      atc.classList.remove('is-loading');
      if (atcText) atcText.textContent = atcOriginal;
    }
    /* Back button from checkout restores the page from cache with the button still
       in "Lägger till…" state. Unfreeze it whenever the page is shown again. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { resetAtc(); showErr(''); }
    });

    /* ---------- Size guide ---------- */
    var guide = root.querySelector('[data-guide]');
    var openG = root.querySelector('[data-open-guide]');
    if (guide && openG) {
      openG.addEventListener('click', function () {
        if (typeof guide.showModal === 'function') guide.showModal(); else guide.setAttribute('open', '');
      });
      var closeG = guide.querySelector('[data-close-guide]');
      if (closeG) closeG.addEventListener('click', function () { guide.close ? guide.close() : guide.removeAttribute('open'); });
      guide.addEventListener('click', function (e) {
        if (e.target === guide && guide.close) guide.close();
      });
    }

    /* ---------- Sticky add-to-cart (mobile) ---------- */
    var sticky = root.querySelector('[data-sticky-atc]');
    function updateSticky() {
      if (!sticky) return;
      var t = tiers[state.tier];
      var title = sticky.querySelector('[data-sticky-title]');
      var price = sticky.querySelector('[data-sticky-price]');
      if (t) {
        var tt = t.querySelector('.tier-text strong');
        var tp = t.querySelector('[data-tier-price]');
        if (title && tt) title.textContent = tt.textContent;
        if (price && tp) price.textContent = tp.textContent;
      }
    }
    if (sticky && atc && 'IntersectionObserver' in window) {
      var sb = sticky.querySelector('[data-sticky-btn]');
      if (sb) sb.addEventListener('click', function () { atc.click(); });
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (sb) sb.tabIndex = show ? 0 : -1;
          document.body.classList.toggle('has-sticky-atc', show);
        });
      }).observe(atc);
    }
    var _render = renderRows;
    renderRows = function () { _render(); updateSticky(); };

    syncMain();
    renderRows();
  }

  /* ---------- Testimonial slider ---------- */
  function initTracks() {
    document.querySelectorAll('.testimonials').forEach(function (sec) {
      var track = sec.querySelector('[data-track]');
      if (!track || track.dataset.initialized) return;
      track.dataset.initialized = 'true';
      function step(dir) {
        var card = track.querySelector('.t-card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 24;
        var w = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        var max = track.scrollWidth - track.clientWidth;
        var left = track.scrollLeft + dir * w;
        if (dir > 0 && track.scrollLeft >= max - 2) left = 0;
        if (dir < 0 && track.scrollLeft <= 2) left = max;
        track.scrollTo({ left: left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      var p = sec.querySelector('[data-track-prev]'), n = sec.querySelector('[data-track-next]');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });
  }

  /* ---------- Show more imported customer reviews ---------- */
  function initReviews() {
    document.querySelectorAll('[data-reviews]').forEach(function (sec) {
      if (sec.dataset.initialized) return;
      var cards = Array.from(sec.querySelectorAll('[data-review-card]'));
      var button = sec.querySelector('[data-reviews-more]');
      var status = sec.querySelector('[data-review-status]');
      if (!button || !cards.length) return;
      sec.dataset.initialized = 'true';
      var batch = Math.max(1, parseInt(sec.dataset.initialCount, 10) || 8);
      var visible = Math.min(batch, cards.length);
      function update() {
        cards.forEach(function (card, index) { card.hidden = index >= visible; });
        button.hidden = visible >= cards.length;
        if (status) status.textContent = (I18N.showing || 'Visar {shown} av {total} omdömen').replace('{shown}', visible).replace('{total}', cards.length);
      }
      button.addEventListener('click', function () {
        var firstNew = cards[visible];
        visible = Math.min(visible + batch, cards.length);
        update();
        if (firstNew) firstNew.focus({ preventScroll: true });
      });
      update();
    });
  }

  function boot() {
    document.querySelectorAll('[data-product]').forEach(initProduct);
    initTracks();
    initReviews();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Re-init when sections reload in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product]').forEach(initProduct);
    initTracks();
    initReviews();
  });

  window.NordSock = { fmtKr: fmtKr };
})();
